import { Paperclip } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDate, money } from "@/lib/finance";
import { VoidButton } from "@/components/finance/VoidButton";

const openProof = async (id) => {
  const win = window.open("", "_blank");
  try {
    const { data } = await api.get(`/files/${id}`, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    if (win) win.location.href = url; else window.location.href = url;
  } catch (e) {
    win?.close();
    toast.error(errMsg(e));
  }
};

const OUTFLOW = ["retiro", "pago_capital", "pago_interes", "retorno"];

export const MovementsList = ({ movements, labels, onVoid }) => (
  <ul data-testid="movements-list" className="divide-y c-line">
    {movements.length === 0 && <li className="py-4 text-sm c-muted">Sin movimientos registrados.</li>}
    {movements.map((m) => (
      <li key={m.id} data-testid={m.voided ? "movement-item-voided" : "movement-item"} className={`py-3 flex items-start justify-between gap-3 ${m.voided ? "opacity-60" : ""}`}>
        <div className="min-w-0">
          <p className="font-semibold text-sm">{labels[m.type] || m.type}{m.voided && <span className="ml-2 text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-red-500/15 text-red-600 dark:text-red-400">Anulado</span>}</p>
          {m.voided && <p className="text-[11px] c-muted">Anulado por {m.voided_by_name}{m.void_reason ? ` · ${m.void_reason}` : ""}</p>}
          <p className="text-xs c-muted">{fmtDate(m.date) || "Sin fecha"}{m.notes ? ` · ${m.notes}` : ""}</p>
          {m.source_note && <p className="text-[11px] c-muted font-mono truncate">{m.source_note}</p>}
          {m.proof_file_id && (
            <button data-testid="movement-proof-open-btn" onClick={() => openProof(m.proof_file_id)} className="mt-1 inline-flex items-center gap-1 text-xs c-accent underline-offset-2 hover:underline">
              <Paperclip className="w-3 h-3" /> Ver comprobante
            </button>
          )}
          {!m.voided && onVoid && <div><VoidButton onConfirm={(reason) => onVoid(m, reason)} /></div>}
        </div>
        <span className={`font-mono text-sm tabular-nums whitespace-nowrap ${m.voided ? "line-through" : OUTFLOW.includes(m.type) ? "text-emerald-600 dark:text-emerald-400" : ""}`}>{money(m.amount, m.currency)}</span>
      </li>
    ))}
  </ul>
);
